module.exports = __webpack_public_path__ + "static/img/52.6a7d160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/52.png
// module id = uh/u
// module chunks = 0